import React from 'react'
import ProjectContent from './Components/project';
import {Helmet} from 'react-helmet';
import ProjectHead from '../../Components/Head/projecthead';


function Project() {
  return (
    <>
        <Helmet>
          <title>Yash Admin Sales Management System</title>                                                                                                                                                                                                                                 
        </Helmet>
        <div>
            <ProjectHead />
            <ProjectContent />
        </div>
    </>
  )
}

export default Project